// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.title[data-v-03ae6f97] {\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n.subscriber-stats-container[data-v-03ae6f97] {\n  position: absolute;\n  height: 200px;\n  width: 300px;\n  top: 100px;\n  left: 38px;\n  z-index: 10;\n  background: #2c2d30;\n  border: 2px white solid;\n  border-radius: 8px;\n  padding: 8px;\n  font-size: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
